import React from "react";
import ErrorModal from "../Shared/Modals/ErrorModal/ErrorModal";
import { Router } from "next/router";

type IProps = {
  children: React.ReactNode;
  router: Router;
};

type IState = { hasError: boolean; errorInfo: any };

class ErrorBoundary extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true,
      errorInfo: error.message
    });
  }

  resetErrorAndRedirect = () => {
    this.setState({ hasError: false, errorInfo: null });
    const { pathname } = this.props.router;
    const p = (pathname as string).split("/");
    this.props.router.push(`/${p[1]}`);
  };

  render() {
    if (this.state.hasError) {
      return <ErrorModal error={this.state.errorInfo} onClose={this.resetErrorAndRedirect} />;
    }

    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
